import HelpLayout from "@/components/layout/HelpLayout";
import { ChamadosManager } from "@/components/pages/chamados/ChamadosManager";
import HelpNavigationTabs from "@/components/ui/help-navigation-tabs";
import PendenciaCard from "@/components/ui/pendencia-card";

export default function ChamadosAbertosPage() {
  return (
    <HelpLayout title="Chamados em aberto">
      <div className="w-full overflow-hidden">
        <PendenciaCard mode="screen" screenName="FAQ / Suporte" />

        <div className="mt-6 w-full overflow-hidden rounded-2xl border border-gray-200 bg-white p-3 shadow-sm sm:p-6">
          <HelpNavigationTabs className="mb-4 sm:mb-6" />

          <ChamadosManager />
        </div>
      </div>
    </HelpLayout>
  );
}
